import React from 'react';
import { Box, Text, Image, Flex } from '@chakra-ui/react';
// Importa useNavigate desde react-router-dom
import { useNavigate } from 'react-router-dom';

function Level(props ) {
    const { zIndex } = props;
    // Hook useNavigate para manejar la navegación
    const navigate = useNavigate();

    // Función para manejar el clic en el Box central
    const handleBoxClick = () => {
        navigate(props.navigate); // Cambia '/ruta-destino' por tu ruta específica
    };

    return (
        <Box zIndex={zIndex} style={{ position: "relative" }}>
            <Flex
                direction="column"
                align="center"
                justify="center"
                gap={{ base: "24px 52px", sm: "24px 52px" }}
                height="100vh"
                zIndex={props.zIndex}
            >
                {/* Primer Box */}
                <Box
                    width="48px"
                    height="48px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bg={props.backgroundColor || "#FCEBA2"}
                    borderRadius="50%"
                    flexShrink={0}
                >
                    <Text
                        color="#000"
                        fontFamily="Inter"
                        fontSize="24px"
                        fontStyle="normal"
                        fontWeight="600"
                        lineHeight="25px"
                        letterSpacing="-0.01px"
                    >
                        {props.number}
                    </Text>
                </Box>

                {/* Box Central con Click */}
                <Box
                    width="211px"
                    height="211px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bg="white"
                    borderRadius="50%"
                    borderWidth="6px"
                    borderColor={props.borderColor || "#FCEBA2"}
                    flexShrink={0}
                    overflow="hidden"
                    p="10px"
                    mt="24px"
                    onClick={handleBoxClick} // Agrega el manejador de clic aquí
                    cursor="pointer" // Cambia el cursor a pointer para indicar que es clickeable
                >
                    <Image
                        src={props.img}
                        alt="Descripción de la imagen"
                        maxW="100%"
                        maxH="100%"
                        objectFit="contain"
                    />
                </Box>

                {/* Tercer Box */}
                <Box mt="52px">
                    <Text
                        color="#303030"
                        textAlign="center"
                        fontFamily="Poppins, sans-serif"
                        fontSize="24px"
                        fontStyle="normal"
                        fontWeight="600"
                        lineHeight="38px"
                        letterSpacing="-0.01px"
                    >
                        {props.text}
                    </Text>
                </Box>
            </Flex>
        </Box>
    );
}

export default Level;
